import type React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import type { TestProps } from '../../models';
import { PricingCalculator } from '../../utils/pricingCalculator';
import { fCurrency } from '../../utils/formatNumber';

export const TestTotalSummary = ({
	tests,
}: {
	tests: TestProps[];
}) => {
	const theme = useTheme();
	const pricedTests = tests.map((test) => ({
		...test,
		price: test.discountedPrice ?? test.price,
	}));

	const price = new PricingCalculator(pricedTests);

	return (
		<Stack spacing={1}>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="subtitle1" fontWeight="bold">
					Subtotal
				</Typography>
				<Box sx={{ textAlign: 'right' }}>
					<Typography variant="subtitle1" sx={{ color: theme.palette.common.black }} fontWeight="bold">
						{fCurrency(price.subtotal())}
					</Typography>
				</Box>
			</Stack>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="subtitle1" fontWeight="bold">
					GST (10%)
				</Typography>
				<Box sx={{ textAlign: 'right' }}>
					<Typography variant="subtitle1" sx={{ color: theme.palette.common.black }} fontWeight="bold">
						{fCurrency(price.gst())}
					</Typography>
				</Box>
			</Stack>
			<Stack direction="row" justifyContent="space-between">
				<Typography className="RequestTestTotalKey" variant="h4" fontWeight="bold">
					Total (inc. GST)
				</Typography>
				<Box sx={{ textAlign: 'right' }}>
					<Typography
						className="RequestTestTotalValue"
						variant="h4"
						sx={{ color: theme.palette.common.black }}
						fontWeight="bold"
					>
						{fCurrency(price.total())}
					</Typography>
				</Box>
			</Stack>
		</Stack>
	);
};
